"use client";

import * as React from "react";
import Footer from "@/components/ui/footer";
import "@/app/globals.css";
import { Button } from "@mui/material";
import AboutSports from "./components/AboutSports-Screen";
import HowItWorksSportsScreen from "./components/HowItWorksSports-Screen";
import AssignatureSportsScreen from "./components/AssignatureSports-Screen";

const panelVideo = "/videos/Sports.mp4";

export default function Sports() {
  return (
    <>
      <div>
        <title>Sports</title>

        <section className="relative flex items-center w-auto h-[60vh] flex-shrink-0 justify-center max-[820px]:w-50vh">
          <video autoPlay loop muted className="w-full h-full object-cover">
            <source src={panelVideo} type="video/mp4" />
          </video>
          <div className="absolute flex w-full h-full bg-black opacity-60"></div>
          <div className="absolute flex flex-col justify-center items-center">
            <p className="text-white text-[30px] ">
              {" "}
              Seus lances nunca foram tão faceis de relembrar!
            </p>
            <div className="flex flex-row justify-center w-full">
              <Button
                sx={{
                  my: 10,
                  width: "52",
                  m: "1px",
                }}
                variant="contained"
                href="/"
              >
                Voltar para home
              </Button>
              <Button
                sx={{
                  my: 10,
                  width: "52",
                  m: "1px",
                }}
                variant="contained"
                style={{ backgroundColor: "#F97316" }}
                href="https://alertai.com.br/sports"
              >
                Ir para o Sports
              </Button>
            </div>
          </div>
        </section>

        <AboutSports></AboutSports>
        <AssignatureSportsScreen />
        <HowItWorksSportsScreen />
        <Footer></Footer>
      </div>
    </>
  );
}
